import { formatCurrency, formatNumber, formatPercent } from 'util/formatters';

import {
  DynamicMultiSelectFilterConfig,
  FilterConfig,
  FiltersState,
  FilterType,
  PillsState,
  StaticSelectFilterConfig,
} from './types';

export function getActiveFilterPills<T>(
  filtersState: FiltersState,
  filterConfigs: FilterConfig<T>[],
) {
  return Object.entries(filtersState).flatMap((filter) => {
    const [filterKey, filterState] = filter;
    const config = filterConfigs.find((c) => c.id === filterKey);
    if (!config) {
      return [];
    }

    if ('search' in filterState) {
      return {
        id: filterKey,
        key: filterKey,
        value: filterState,
        type: 'search',
        label: `Search: "${filterState.search}"`,
      };
    } else if ('min' in filterState || 'max' in filterState) {
      if (filterState.min === undefined && filterState.max !== undefined) {
        return {
          id: filterKey,
          key: filterKey,
          value: filterState,
          type: 'range',
          label: `${config.name}: <${formatLabel(filterKey, filterState.max)}`,
        };
      } else if (filterState.min !== undefined && filterState.max === undefined) {
        return {
          id: filterKey,
          key: filterKey,
          value: filterState,
          type: 'range',
          label: `${config.name}: ${formatLabel(filterKey, filterState.min)}+`,
        };
      } else if (filterState.min !== undefined && filterState.max !== undefined) {
        return {
          id: filterKey,
          key: filterKey,
          value: filterState,
          type: 'range',
          label: `${config.name}: ${formatLabel(filterKey, filterState.min)} - ${formatLabel(
            filterKey,
            filterState.max,
          )}`,
        };
      } else {
        return [];
      }
    } else if ('options' in filterState && filterState.options) {
      return filterState.options.map((option) => ({
        id: filterKey,
        key: filterKey + option,
        value: option,
        type: 'options',
        label: `${config.name}: ${
          config.type === FilterType.STATIC_SELECT
            ? (config as StaticSelectFilterConfig<unknown>).options[option]?.label
            : config.type === FilterType.TOGGLE_SELECT
              ? 'selected'
              : config.type === FilterType.DYNAMIC_MULTI_SELECT &&
                  (config as DynamicMultiSelectFilterConfig<unknown>).getOptionLabel
                ? ((config as DynamicMultiSelectFilterConfig<unknown>).getOptionLabel?.(option) ??
                  option)
                : option
        }`,
        reverse: config.type === FilterType.DYNAMIC_SELECT ? config.reverse : undefined,
      })) as PillsState[];
    } else {
      return [];
    }
  });
}

function formatLabel(filterKey: string, value: number) {
  switch (filterKey) {
    case 'price':
    case 'markdown':
      return formatCurrency(value);
    case 'currentPriceToMarket':
      return formatPercent(value / 100);
    default:
      return formatNumber(value);
  }
}
